
$(document).ready(function() {




    $('.horizontal-nav.ajax li a').click(function(e) {
        $('.horizontal-nav.ajax li a').removeClass('active');

        $(this).addClass('active');
        e.preventDefault();
        e.stopPropagation();
        url = $(this).attr('href')+'?type=5001';


        $.ajax({
            url: url,
            success: function (data) {
                $('#reference-load').html(data);

                console.log('LOAD22222');


            },
            error: function (jqXHR, textStatus, errorThrown) { errorFunction(); }
        });
    })




    // ----------------------------------------------------------------------------------
    // Full-Service-Menü
    // ----------------------------------------------------------------------------------
    if ($('.horizontal-nav.ajax li a').length) {
        $('.horizontal-nav.ajax li a')[0].click();
    }


    // ----------------------------------------------------------------------------------
// Referenzfinder
// ----------------------------------------------------------------------------------
    $("#finder-category,#finder-customer").change(function () {

        //history.pushState("", document.title, window.location.pathname);

        var selectedCategory = $("#finder-category").val();
        var selectedCustomer = $("#finder-customer").val();

        hashs = [];
        if (selectedCategory != '') {
            hashs.push('leistung_' + selectedCategory);
        }

        if (selectedCustomer != '') {
            hashs.push('kunde_' + selectedCustomer);
        }

        if (hashs.length > 0) {
            window.location.hash = hashs.join('/');
        } else {
            removeHash();
        }

        var found = 0;

        $('.reference-item').fadeOut(100);

        $('.reference-item').each(function () {
            var reference = $(this);
            var refCategory = $(this).data('category');
            var refCustomer = $(this).data('customer');
            if ((refCategory == selectedCategory || selectedCategory <= 0) && (refCustomer == selectedCustomer || selectedCustomer <= 0)) {
                reference.fadeIn(500);
                found++;
            } else {

            }
        })

        if (found > 0) {
            $('#no-results-references').fadeOut(100);
        } else {
            $('#no-results-references').fadeIn(500);
        }
    });

// Schaut ob eine Referenzkategorie oder Kunde übergeben wurde
    var hash = location.hash.substr(1);


    if (hash != "") {
        var parts = hash.split('/');
        scrolled=false;

            for (e = 0; e < parts.length; e++) {
                var valueParts = parts[e].split('_');
                if (valueParts[0] == 'leistung') {
                    $("#finder-category").val(valueParts[1]);
                    $("#finder-category").change();
                    scrolled = true;
                    scrollToTarget($('.finder-box'));
                    //$('#finder-category').selectric('referesh');

                }
                // if (valueParts[0] == 'kunde') {
                //     $("#finder-customer").val(valueParts[1]);
                //     $("#finder-customer").change();
                //     // $('#finder-customer').selectric('referesh');
                //
                // }
            }

        if (!scrolled) {
            scrollToTarget($('#'+hash));
        }



        // // Hash schon beim Laden vorhanden?
        // var hash = window.location.hash;
        // var target = $(hash);
        // scrollToTarget(target);

    }
});